@if (selectedSortItem$ | async; as selectedSortItem) {
    <div class="activity-filter">
        <priva-filter-search
            [config]="filterSearchConfig"
            [dataSource]="activitiesDataSource"
            class="activity-filter__search"
            data-test="search-activity-bar"
        />
        <priva-selection-group
            type="radio"
            name="options"
            [items]="sortingGroupItems"
            [selectedItem]="selectedSortItem"
            (toggle)="sortItemSelected($event)"
        />
    </div>
}
